<div
  class="mobile-nav-overlay"
  [class.show]="isOpen()"
  (click)="closeNav()"
  aria-hidden="true"
></div>

<div class="mobile-nav-container" [class.show]="isOpen()" role="navigation" aria-label="Mobile navigation">
  <div class="mobile-nav-content">
    <ul class="mobile-nav-list" role="list">
      <!-- Super User Menu -->
      @if (isSuperUserLoggedIn()) {
        <li
          class="mobile-nav-item super-user-item"
          [class.active]="superMenuSelected()"
          role="listitem"
        >
          <button class="nav-item-content" (click)="onSuperUserClick()" aria-label="Super User Dashboard">
            <img
              src="../../../../assets/img/activitypro-logo.png"
              alt="Super User Dashboard"
              class="nav-icon"
            />
            <span class="nav-text">Super User Dashboard</span>
          </button>
        </li>
      }

      <!-- Regular Menu Items -->
      @for (menu of menus(); track menu; let i = $index) {
        <li
          class="mobile-nav-item"
          [class.has-submenu]="menu.subMenu.length > 0"
          [class.active]="isParentMenuSelected(i) || selectedMenuIndex() === i"
          role="listitem"
        >
          <button class="nav-item-content" (click)="toggleSubmenu(menu, i)" [attr.aria-expanded]="menu.subMenu.length > 0 ? menu.isClicked : null">
            <img [src]="menu.icon" [alt]="menu.name" class="nav-icon" />
            <span class="nav-text">{{ menu.name }}</span>
            @if (menu.subMenu.length > 0) {
              <i
                class="fa-solid fa-chevron-down submenu-arrow"
                [class.rotated]="menu.isClicked"
                aria-hidden="true"
              ></i>
            }
          </button>
          @if (menu.subMenu.length > 0) {
            <ul
              class="mobile-submenu"
              [class.show]="menu.isClicked"
              role="list"
            >
              @for (subMenu of menu.subMenu; track subMenu; let j = $index) {
                <li
                  class="mobile-submenu-item"
                  [class.active]="selectedSubMenuIndex() === j && selectedMenuIndex() === i"
                  role="listitem"
                >
                  <button class="submenu-btn" (click)="subMenuRoute(subMenu, j, i)">
                    <img [src]="subMenu.icon" [alt]="subMenu.name" class="submenu-icon" />
                    <span class="submenu-text">{{ subMenu.name }}</span>
                  </button>
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>

    <button class="mobile-logout-btn" (click)="onLogout()" aria-label="Log out">
      <i class="pi pi-sign-out" aria-hidden="true"></i>
      <span class="nav-text">Log out</span>
    </button>
  </div>
</div>
